import React, {memo} from "react";

function Description(props) {
    const { record } = props;

    return (
        <div className="BaseTable__row-cell-text">
            {record.description || '-'}
        </div>
    );
}

export default memo(Description);
